import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import { getDashboardData } from "../services/companyServices";

function formatDateTime(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return (
    date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }) +
    ", " +
    date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    })
  );
}

const Dashboard = () => {
  const { login } = useContext(AppContext);
  const [data, setData] = useState({});
  const [copySuccess, setCopySuccess] = useState(false);

  const getData = async () => {
    const result = await getDashboardData(login.token);
    if (result.success) {
      setData(result.data);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const key = data.key || {};
  const sync = data.sync || {};

  const handleCopy = () => {
    if (key.key) {
      navigator.clipboard.writeText(key.key);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1500);
    }
  };

  return (
    <div className="details-table mt-3 container py-4">
      <h2 className="mb-4">Dashboard</h2>
      <div className="row g-4">
        {/* Key Info Card */}
        <div className="col-md-6">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Subscription Key</h5>
              {key.key ? (
                <>
                  <div className="mb-2 d-flex align-items-center">
                    <strong>Key:</strong>
                    <span className="text-monospace ms-2">{key.key.slice(0, 24)}...</span>
                    <button
                      className="btn btn-outline-secondary btn-sm ms-2"
                      onClick={handleCopy}
                      title="Copy Key"
                      style={{ padding: "2px 10px" }}
                    >
                      📋
                    </button>
                    {copySuccess && (
                      <span className="ms-2 text-success" style={{ fontSize: "0.9em" }}>
                        Copied!
                      </span>
                    )}
                  </div>
                  {/* ...rest of your fields... */}
                  <div className="mb-2">
                    <strong>Status:</strong>{" "}
                    <span className={`badge ${key.status === "Approved" ? "bg-success" : "bg-secondary"}`}>{key.status}</span>
                  </div>
                  <div className="mb-2">
                    <strong>Type:</strong> {key.keyType}
                  </div>
                  <div className="mb-2">
                    <strong>Users Allowed:</strong> {key.user}
                  </div>
                  <div className="mb-2">
                    <strong>Tracking:</strong> {key.tracking ? "Enabled" : "Disabled"}
                  </div>
                  <div className="mb-2">
                    <strong>Advertisement:</strong> {key.advertisment ? "Enabled" : "Disabled"}
                  </div>
                  <div className="mb-2">
                    <strong>Calling:</strong> {key.calling ? "Enabled" : "Disabled"}
                  </div>
                  <div className="mb-2">
                    <strong>Expires At:</strong> {formatDateTime(key.expiringAt)}
                  </div>
                  <div className="mb-2">
                    <strong>Total:</strong> ₹{key.total}
                  </div>
                  {key.breakdown && key.breakdown[0] && (
                    <div className="mb-2">
                      <strong>Breakdown:</strong>
                      <ul className="mb-0">
                        <li>Users: {key.breakdown[0].user.users}</li>
                        <li>Price/User: ₹{key.breakdown[0].user.pricePerUser}</li>
                        <li>Days: {key.breakdown[0].user.diffInDays}</li>
                        <li>Gross: ₹{key.breakdown[0].user.gross}</li>
                        <li>GST: ₹{key.breakdown[0].user.gst}</li>
                        <li>Discount: {key.breakdown[0].user.discountPercent}% (₹{key.breakdown[0].user.discountAmount})</li>
                        <li>Net: ₹{key.breakdown[0].user.net}</li>
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <div className="text-muted">No key data available.</div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Synced Data</h5>
              {sync._id ? (
                <>
                  <div className="mb-2">
                    <strong>Version:</strong> {sync.version}
                  </div>
                  <div className="mb-2">
                    <strong>Users:</strong> {sync.user}
                  </div>
                  <div className="mb-2">
                    <strong>Groups:</strong> {sync.group}
                  </div>
                  <div className="mb-2">
                    <strong>Departments:</strong> {sync.department}
                  </div>
                  <div className="mb-2">
                    <strong>Tracking:</strong> {sync.tracking}
                  </div>
                  <div className="mb-2">
                    <strong>Last Sync:</strong> {formatDateTime(sync.syncAt)}
                  </div>
                  <div className="mb-2">
                    <strong>Messages:</strong>
                    <ul className="mb-0">
                      <li>
                        <strong>Private:</strong> {sync.messages?.private?.text || 0} text, {sync.messages?.private?.file || 0} files
                      </li>
                      <li>
                        <strong>Group:</strong> {sync.messages?.group?.text || 0} text, {sync.messages?.group?.file || 0} files
                      </li>
                    </ul>
                  </div>
                  <div className="mb-2">
                    <strong>Calls:</strong>
                    <ul className="mb-0">
                      <li>
                        <strong>Private:</strong> {sync.call?.private?.call || 0}
                      </li>
                      <li>
                        <strong>Group:</strong> {sync.call?.group?.call || 0}
                      </li>
                    </ul>
                  </div>
                </>
              ) : (
                <div className="text-muted">No sync data available.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
